/**
 * Token-occupancy predicate.
 *
 * Mirrors the PHP-side TokenOccupancy so client and server agree on what
 * counts as a blocking token. A cell is "occupied" by a token T when:
 *   - T.is_placed is true
 *   - T.grid_x, T.grid_y match the cell
 *   - T.is_downed is false (downed tokens are passable — step over the body)
 *   - T.id !== excludeTokenId (a token moving from its own cell doesn't block itself)
 *
 * Pure / DOM-free so it can be unit-tested in node.
 */

import type { Token } from './types.js';

export function isCellOccupied(
  tokens: readonly Token[],
  gridX: number,
  gridY: number,
  excludeTokenId?: number,
): boolean {
  for (const t of tokens) {
    if (!t.is_placed) continue;
    if (t.is_downed) continue;
    if (t.grid_x !== gridX || t.grid_y !== gridY) continue;
    if (excludeTokenId !== undefined && t.id === excludeTokenId) continue;
    return true;
  }
  return false;
}
